export default "__VITE_ASSET__Cn56En3O__"